import { Menu, pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledMenu = styled(Menu) `
  width: ${pxToRem(300)};
  max-width: 100%;
  padding: ${themeGet('spacing.sm')} ${themeGet('spacing.md')};
`;
